/* eslint-disable array-bracket-newline */
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Image from '../../../atoms/Image';
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import { networks } from '../../NetworkSelector/core';
import { actionOpenTickers } from '../../../actions/modal';
import {
  DEFAULT_URL_PATH,
  DEFAULT_OVERVIEW_WALLET,
} from '../../../helpers/constants';
import { StorageKeys } from '../../../helpers/localStorage';
import useDevice from '../../../pages/MainPage/useMobileDetect';

import logo from '../../../assets/images/kattana_logo.svg';
import analyzerImage from './images/analyzer.png';
import tradingImage from './images/trading.png';

import './styles.scss';

interface IWelcomeModalProps {
  onCancel(): void;
}

const WelcomeModal = ({ onCancel }: IWelcomeModalProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const { isDesktop } = useDevice();

  const onClose = () => {
    window.localStorage?.setItem(StorageKeys.welcomed, 'true');
    onCancel();
  };

  const onOpenSearch = () => {
    onClose();
    if (isDesktop) {
      dispatch(actionOpenTickers({ center: false }));
    }
  };

  const onOpenAnalyzer = () => {
    navigate(
      `/en/wallet-overview/${params.chain || 'ETH'}/${DEFAULT_OVERVIEW_WALLET}`
    );
    onClose();
  };

  const onOpenTrading = () => {
    navigate(DEFAULT_URL_PATH);
    onClose();
  };

  return (
    <div className='welcome_modal no_scroll'>
      <div className='welcome_modal__close icon-close' onClick={onClose} />
      <div className='welcome_modal__left_block'>
        <div className='welcome_modal__left_block__search'>
          <div className='welcome_modal__left_block__search__logo'>
            <Image
              src={logo}
              size='m'
              className='welcome_modal__left_block__search__logo__image'
            />
            <div className='welcome_modal__left_block__search__logo__description'>
              <Text
                size={18}
                className='welcome_modal__left_block__search__logo__description__title'
              >
                Kattana
              </Text>
              <Text
                size={14}
                className='welcome_modal__left_block__search__logo__description__subtitle'
              >
                Find. Analyze. Trade. Success
              </Text>
            </div>
          </div>
          <div
            className='welcome_modal__left_block__search__find'
            onClick={onOpenSearch}
          >
            <div className='welcome_modal__left_block__search__find__icons'>
              <div className='icon-search' />
              <div className='icon-chevron-down' />
            </div>
            <Text
              size={14}
              className='welcome_modal__left_block__search__find__placeholder'
            >
              Search through 5M+ trading pairs
            </Text>
          </div>
          <div className='welcome_modal__left_block__search__networks'>
            <div className='welcome_modal__left_block__search__networks__list'>
              {networks.slice(0, 14).map((network) => (
                <Image
                  key={network.chain}
                  src={network.getImage()}
                  size='l'
                  alt={network.getName()}
                  className={`welcome_modal__left_block__search__networks__list--${network.chain}`}
                />
              ))}
            </div>
            <Text size={12} className='text--grey-400'>
              * 19 Networks with all majority DEXs on them
            </Text>
          </div>
        </div>
        <div className='welcome_modal__left_block__analyzer'>
          <div className='welcome_modal__left_block__analyzer__image'>
            <img src={analyzerImage} alt='Analyzer tool' />
          </div>
          <Text
            size={24}
            className='welcome_modal__left_block__analyzer__title'
          >
            Wallet magic analyzer tool
          </Text>
          <div className='welcome_modal__left_block__analyzer__tags'>
            <TagRow
              labels={[
                'Thousands of identified traders, investors and influencers wallets',
              ]}
            />
            <TagRow
              labels={['Complex statistic', 'All transactions on all networks']}
            />
            <Button
              action={onOpenAnalyzer}
              size='m'
              variant='primary'
              text='Open'
            />
          </div>
        </div>
      </div>
      <div className='welcome_modal__right_block'>
        <div className='welcome_modal__right_block__image'>
          <img src={tradingImage} alt='Premium features' />
        </div>
        <Text size={24} className='welcome_modal__right_block__title'>
          Get unlimited trading power with Premium features
        </Text>
        <Button
          action={onOpenTrading}
          size='m'
          variant='primary'
          text='Unleash your trading master now '
        />
        <div className='welcome_modal__right_block__tags'>
          <TagRow labels={['Advanced Limit Orders for DEXs']} />
          <TagRow labels={['No limitations for features']} />
          <TagRow labels={['Complete access to wallets DB']} />
          <TagRow labels={['V3 liquidity charts']} />
          <TagRow labels={['1-sec Timeframes', 'and More']} />
        </div>
      </div>
    </div>
  );
};

const TagRow = ({ labels }: { labels: string[] }) => {
  return (
    <div className='welcome_modal__tag_row'>
      {labels.map((label) => (
        <div key={label} className='welcome_modal__tag_row__item'>
          <div className='welcome_modal__tag_row__item__icon icon-check-circle' />
          <Text size={14} className='text--white'>
            {label}
          </Text>
        </div>
      ))}
    </div>
  );
};

export default WelcomeModal;
